const views = {
  ['DEFAULT']: () => ({
    bodyText:
      "To create a Zap with more than one action, you'll need a paid plan. Edit your zap or upgrade now to turn on your Zap.",
    type: 'DEFAULT',
  }),

  ['TRIAL_EXTENSION']: () => ({
    bodyText:
      "To create a Zap with more than one action, you'll need a paid plan. Upgrade now or start a free 7-day trial of the Professional plan to use multi-step Zaps.",
    type: 'TRIAL_EXTENSION',
  }),
};

type Props = {
  canExtendTrial: boolean;
};

export const getActiveView = ({ canExtendTrial }: Props) =>
  canExtendTrial ? views.TRIAL_EXTENSION() : views.DEFAULT();
